import {
  Button,
  ButtonStyles,
  useTranslation,
  useBreakpoint,
  Breakpoints,
  ButtonSize,
  NextgenImage,
  LoaderType,
} from '@nextgen-web-framework/all';
import { FC } from 'react';
import styles from './Welcome.module.scss';
import type { WelcomeProps } from './types/propTypes';

const Welcome: FC<WelcomeProps> = (props: WelcomeProps): JSX.Element => {
  const viewPortType = useBreakpoint();
  const t = useTranslation();
  const { imageUrl, onClick } = props;
  return (
    <div className={styles['welcome-container']} data-testid="welcome-testid">
      <div className={styles['welcome-img']}>
        <NextgenImage src={imageUrl} alt="Welcome" loaderType={LoaderType.WEBFONTS} isRelativeURL={true} />
      </div>
      <div className={styles['welcome-detail']}>
        <div className={styles['welcome-detail-text']}>
          <div className={styles['welcome-greeting']}>{t('myshop.Welcome.headerTitle')}</div>
          <div className={styles['welcome-message']}>{t('myshop.Welcome.descriptionTitle')}</div>
        </div>
        <div className={styles['btn-start-customizing']}>
          <Button
            buttonStyle={ButtonStyles.OUTLINE}
            size={
              viewPortType == Breakpoints.XS || viewPortType == Breakpoints.MD ? ButtonSize.SMALL : ButtonSize.MEDIUM
            }
            title={t('myshop.Welcome.customizeButtonTitle')}
            onClick={onClick}
          />
        </div>
      </div>
    </div>
  );
};

export default Welcome;
